import React from "react"
import ReactHtmlParser from "react-html-parser"

export default function NewsContentImageBlock(props) {
  return (
    <div className="news-content-image">
      <img src={props.newsArticleImage} alt={props.articleText}></img>
      {ReactHtmlParser(props.imageCaption)}
    </div>
  )
}
